module.exports = __webpack_public_path__ + "img/31.6cec32d2.jpg";